import React from 'react'
import { Link } from 'react-router-dom'
import Box from '@mui/material/Box'
import Tooltip from '@mui/material/Tooltip'
import ModeEditIcon from '@mui/icons-material/ModeEdit'
import { createListLinkTarget } from '../utils/listPageState'
import { LIST_ACTION_EDIT_BUTTON_SX } from './listActionIconStyles'

export default function EditIcon(props) {
    if (props.disabled) {
        return (
            <Tooltip title="Edit">
                <Box
                    component="span"
                    sx={{
                        ...LIST_ACTION_EDIT_BUTTON_SX,
                        color: 'text.disabled',
                        opacity: 0.5,
                        cursor: 'default',
                    }}
                >
                    <ModeEditIcon />
                </Box>
            </Tooltip>
        )
    }

    return (
        <Tooltip title="Edit">
            <Box
                component={Link}
                to={createListLinkTarget({
                    pathname: `/${props.path}/${props.id}`,
                    search: props.search,
                    id: props.id,
                    type: props.type,
                    curPage: props.curPage,
                    searchText: props.searchText,
                    searchSelect: props.searchSelect,
                    startTime: props.startTime,
                    endTime: props.endTime,
                })}
                sx={LIST_ACTION_EDIT_BUTTON_SX}
            >
                <ModeEditIcon />
            </Box>
        </Tooltip>
    )
}
